import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ds-chip',
  templateUrl: './ds-chip.component.html',
  styleUrls: ['./ds-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DsChipComponent {
  @Input() active: null | boolean;
  @Input() value: number | string;
  @Input() enableUncheck = false;
  @Output() check: EventEmitter<number | string> = new EventEmitter<number | string>();

  onCheck(value: number | string) {
    if (this.active && !this.enableUncheck) {
      return;
    }
    this.check.emit(value);
  }
}
